import React from 'react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../../common/SafeIcon';
import InjuryBadge from './InjuryBadge';

const { FiUser, FiCalendar, FiActivity } = FiIcons;

const InjuryCard = ({ player, onPlayerClick }) => {
  const name = player.person?.fullName || '--';
  const pos = player.position?.abbreviation || '--';
  const posType = player.position?.type || '--';
  const jerseyNum = player.jerseyNumber;
  const status = player.status?.description || player.status?.code || 'IL';
  const note = player.note || null;

  return (
    <div
      className="border border-[rgba(196,51,62,0.4)] bg-[rgba(196,51,62,0.05)] p-3 flex flex-col gap-2 hover:border-[#c4333e] hover:bg-[rgba(196,51,62,0.1)] transition-all cursor-pointer group"
      onClick={() => onPlayerClick && onPlayerClick(player)}
    >
      <div className="flex items-start justify-between gap-2">
        <div className="flex items-center gap-2 min-w-0">
          <div className="w-7 h-7 rounded-full bg-[#386646] border border-[#658d71] flex items-center justify-center shrink-0">
            <SafeIcon icon={FiUser} size={13} className="text-[#a9c9b1]" />
          </div>
          <div className="min-w-0">
            <p className="text-xs font-black uppercase tracking-wide text-white truncate group-hover:text-[#d8ceb3] transition-colors">
              {name}
            </p>
            <div className="flex items-center gap-1.5 mt-0.5">
              {jerseyNum && (
                <span className="text-[9px] text-[#658d71] font-bold">#{jerseyNum}</span>
              )}
              <span className="text-[9px] text-[#a9c9b1] font-bold uppercase">{pos}</span>
              <span className="text-[9px] text-[#658d71]">·</span>
              <span className="text-[9px] text-[#658d71] uppercase tracking-wider">{posType}</span>
            </div>
          </div>
        </div>
        <InjuryBadge status={status} />
      </div>
      {note && (
        <div className="flex items-start gap-1.5 border-t border-[rgba(196,51,62,0.2)] pt-2">
          <SafeIcon icon={FiActivity} size={10} className="text-[#c4333e] mt-0.5 shrink-0" />
          <p className="text-[10px] text-[#a9c9b1] leading-snug">{note}</p>
        </div>
      )}
    </div>
  );
};

export default InjuryCard;